export function getFlagIconForRegion (regionName) {
    switch (regionName) {
    case 'us-east-2':
    case 'us-east-1':
    case 'us-west-1':
    case 'us-west-2':
    case 'us-central1':
    case 'us-east1':
    case 'us-east4':
    case 'us-west1':
    case 'us-west2':
    case 'us-west3':
    case 'us-west4':
        return 'us'
    case 'af-south-1':
        return 'southAfrica'
    case 'ap-east-1':
    case 'asia-east2':
        return 'hongkong'
    case 'ap-southeast-3':
    case 'asia-southeast2':
        return 'indonesia'
    case 'ap-south-1':
    case 'asia-south1':
        return 'india'
    case 'ap-northeast-3':
    case 'asia-northeast1':
    case 'asia-northeast2':
    case 'ap-northeast-1':
        return 'japan'
    case 'ap-northeast-2':
    case 'asia-northeast3':
        return 'southKorea'
    case 'ap-southeast-1':
    case 'asia-southeast1':
        return 'singapore'
    case 'ap-southeast-2':
    case 'australia-southeast1':
        return 'australia'
    case 'europe-north1':
        return 'finland'
    case 'ca-central-1':
    case 'northamerica-northeast1':
        return 'canada'
    case 'eu-central-1':
    case 'europe-west3':
        return 'germany'
    case 'eu-west-1':
        return 'ireland'
    case 'europe-west1':
        return 'belgium'
    case 'eu-west-2':
    case 'europe-west2':
        return 'uk'
    case 'europe-west4':
        return 'netherlands'
    case 'europe-west6':
        return 'switzerland'
    case 'eu-south-1':
        return 'italy'
    case 'eu-west-3':
    case 'europe-west9':
        return 'france'
    case 'eu-north-1':
        return 'sweden'
    case 'me-south-1':
        return 'bahrain'
    case 'sa-east-1':
    case 'southamerica-east1':
        return 'brazil'
    case 'asia-east1':
        return 'taiwan'
    default:
        return 'us'
    }
}
